const validateUrl = (url: string): string => {
  if (url.includes('/../') || /\/%2e%2e\//i.test(url)) {
    throw new Error('Invalid path');
  }
  const parsed = new URL(url);
  if (!['http:', 'https:'].includes(parsed.protocol)) {
    throw new Error('Invalid protocol');
  }
  return parsed.href;
};

export default validateUrl;

